import { getDefaultAccessControlUrl } from './getDefaultAccessControlUrl.mjs';

//
/** @hidden */
function getDefaultAgentMatcherPolicyUrl(resource, name, mode) {
    return getDefaultAccessControlUrl(resource, name)
        .concat("AgentMatcher")
        .concat(mode.charAt(0).toUpperCase() + mode.slice(1))
        .concat("Policy");
}

export { getDefaultAgentMatcherPolicyUrl };
